import axios from "axios";
import axiosCAPApi from "./axiosCAPApi";
import { Cookies } from "react-cookie";
import { appConfig } from "../helpers/common";

const cookies = new Cookies();

const axiosCAPApiPrivate = axios.create({
  baseURL: appConfig.api.baseUrl,
  headers: {
    "Content-Type": "application/json",
    lbcOAkey: appConfig.api.lbcOAkey,
  },
  withCredentials: true,
});

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, accessToken = null) => {
  failedQueue.forEach((prom) => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(accessToken);
    }
  });

  failedQueue = [];
};

axiosCAPApiPrivate.interceptors.request.use(
  (config) => {
    const accessToken = cookies.get("accessToken"); // Retrieve access token from cookies
    if (accessToken) {
      config.headers["Authorization"] = `Bearer ${accessToken}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosCAPApiPrivate.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const originalRequest = error.config;
    if (error.response && (error.response.status === 401 || error.response.status === 403) && !originalRequest._retry) {
      if (isRefreshing) {
        return new Promise(function (resolve, reject) {
          failedQueue.push({ resolve, reject });
        })
          .then(({ accessToken }) => {
            originalRequest.headers["Authorization"] = "Bearer " + accessToken;
            return axiosCAPApiPrivate(originalRequest);
          })
          .catch((err) => {
            return Promise.reject(err);
          });
      }

      originalRequest._retry = true;
      isRefreshing = true;

      return new Promise(function (resolve, reject) {
        axiosCAPApi
          .post("/api/RefreshJWTToken")
          .then((response) => {
            return response.data;
          })
          .then((data) => {
            const newAccessToken = data;
            cookies.set("accessToken", newAccessToken, {
              secure: true,
              path: "/",
              sameSite: "none",
            }); // Update access token in cookies
            axiosCAPApiPrivate.defaults.headers["Authorization"] =
              "Bearer " + newAccessToken;
            originalRequest.headers["Authorization"] =
              "Bearer " + newAccessToken;
            processQueue(null, newAccessToken);
            resolve(axiosCAPApiPrivate(originalRequest));
          })
          .catch((err) => {
            processQueue(err, null);
            reject(err);
          })
          .finally(() => {
            isRefreshing = false;
          });
      });
    }

    return Promise.reject(error);
  }
);

export default axiosCAPApiPrivate;
